import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import hero from '../../assets/hero2.png';
import hero_mobile from '../../assets/hero_mobile.png';
import joinTheClub from '../../assets/join_the_club.png';
import { useGoogleLogin } from '@react-oauth/google';
import axios from "axios";
import Snackbar from '@mui/material/Snackbar';
import Modal from '@mui/material/Modal';
import about_join_us from '../../assets/about-join-us.png'
import home_header_logo from '../../assets/home-header-logo.png'
import home_header_logo_mobile from '../../assets/home-header-mobile-logo.png'
import home_people_mobile from '../../assets/home-mobile-people.png'
import home_people from '../../assets/home-people.png'
import { API_BASE_URL } from '../../config/apiConfig';
import { learnMoreArrow, featureButtonIcon, joinClubIcon, contentImage, buttonIcon } from '../../assets/images';
import { motion, useScroll, useTransform } from 'framer-motion';

export function Hero() {
  const navigate = useNavigate(); 
  const [user, setUser] = React.useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false); 
  const [snackbarMessage, setSnackbarMessage] = React.useState(''); 
  const [modalOpen, setModalOpen] = useState(false); 
  const [email, setEmail] = useState(sessionStorage.getItem('email') || ''); 
  const [scrollDirection, setScrollDirection] = useState('down'); 

  const { scrollY } = useScroll();
  
  // Parallax transforms for the first section
  const logoY = useTransform(scrollY, [0, 1000], [0, 400]);
  const peopleY = useTransform(scrollY, [0, 1000], [0, -150]);
  const marqueeY = useTransform(scrollY, [0, 1000], [0, -150]); // Match people scroll speed
  const textY = useTransform(scrollY, [0, 1000], [0, 100]);
  const textOpacity = useTransform(scrollY, [0, 500, 800], [1, 1, 0]);
  const logoScale = useTransform(scrollY, [0, 1000], [1, 1.1]);

  const handleJoinTheClubClick = useGoogleLogin({
    onSuccess: (codeResponse) => {
      console.log("Google login success:", codeResponse);
      if (codeResponse.access_token) {
        console.log("Access token received:", codeResponse.access_token);
        setUser(codeResponse);
        console.log("User state updated:", codeResponse);
      } else {
        console.error("No access token received from Google");
        setSnackbarMessage('Login failed. Please try again.');
        setSnackbarOpen(true);
      }
    },
    onError: (error) => {
      console.error('Login Failed:', error);
      setSnackbarMessage('Login failed. Please try again.');
      setSnackbarOpen(true);
      console.log("Error details:", error);
    },
    scope: 'email profile',
    flow: 'implicit',
    redirect_uri: window.location.origin,
    ux_mode: 'popup',
  });

  React.useEffect(() => {
    if (user && user.access_token) {
      console.log("Making API call with token:", user.access_token);
      axios
        .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
          headers: {
            Authorization: `Bearer ${user.access_token}`,
            Accept: 'application/json'
          }
        })
        .then((res) => {
          console.log("Google API response:", res.data);
          login(res.data);
        })
        .catch((err) => {
          console.error("Google API error:", err);
          setSnackbarMessage('Failed to get user info. Please try again.');
          setSnackbarOpen(true);
        });
    }
  }, [user]);

  const checkTokenAndLogin = async () => {
    console.log("Checking token and login");
    const existingEmail = sessionStorage.getItem('email');
    const token = sessionStorage.getItem('token');
    if (token && existingEmail) {
      console.log("Email exists in session storage, showing modal");
      // If email exists in session storage, show modal
      setModalOpen(true);
    } else {
      console.log("No email in session storage, proceeding with login");
      // Proceed with login if no email in session storage
      handleJoinTheClubClick();
    }
  };

  const login = async (user) => {
    console.log('Attempting login with user data:', user);
    try {
      const response = await axios.post(`${API_BASE_URL}/user/login`, {
        user: {
          name: user.name,
          email: user.email,
          id: user.id,
          profile_image: user.picture
        },
      });

      console.log("Login API response:", response.data);

      if (response.data.is_success) {
        if (response.data.token) {
          axios({
            method: 'post',
            url: `${API_BASE_URL}/user/get-profile`,
            headers: {
              Authorization: response.data.token
            }
          }).then(res => {
            console.log(res.data);

            console.log(res.data.data[0]);
            if (res.data.data[0].needList?.length > 0) {
              sessionStorage.setItem('token', response.data.token);
              sessionStorage.setItem('email', user.email); // Save email in session storage

              navigate('/profile');
            } else {
              sessionStorage.setItem('token', response.data.token);
              sessionStorage.setItem('email', user.email); // Save email in session storage
              navigate('/personalDetails');

            }

          }).catch(error => {
            console.error('Error fetching profile', error);
          });
        }

      } else {
        console.error("Login failed:", response.data);
        setSnackbarMessage(response.data.message || 'Login failed. Please try again.');
        setSnackbarOpen(true);
      }
      return response.data;
    } catch (error) {
      console.error("Login API error:", error.response || error);
      setSnackbarMessage(error.response?.data?.message || 'Login failed. Please try again.');
      setSnackbarOpen(true);
      return null;
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleUseSameEmail = () => {
    setModalOpen(false);
    const token = sessionStorage.getItem('token');
    axios({
      method: 'post',
      url: `${API_BASE_URL}/user/get-profile`,
      headers: {
        Authorization: token
      }
    }).then(res => {
      console.log(res.data);

      console.log(res.data.data[0]);
      if (res.data.data[0].needList?.length > 0) {

        navigate('/profile');
      } else {
        navigate('/personalDetails');

      }

    }).catch(error => {
      console.error('Error fetching profile', error);
      handleJoinTheClubClick();
    }); // Proceed with the same email
  };

  const handleUseDifferentEmail = () => {
    setModalOpen(false);
    handleJoinTheClubClick();
  };

  const data = [
    {
      id: 1,
      title: "FIRST",
      number: "10,000",
      description: "members will be honoured on our wall of elts",
      buttonText: "WHAT'S WALL OF ELTS?",
    },
  ];

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
    setScrollDirection('up'); // Change direction to up after scrolling down
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setScrollDirection('down'); // Change direction to down after scrolling up
  };

  const handleScrollButtonClick = () => {
    if (scrollDirection === 'down') {
      scrollToBottom();
    } else {
      scrollToTop();
    }
  };

  return (
    <ScreenContainer>
      <Section as={motion.div} style={{ overflow: 'hidden' }}>
        <SectionImage 
          as={motion.img} 
          src={window.innerWidth <= 991 ? home_header_logo_mobile : home_header_logo} 
          alt="Hero"
          style={{ y: logoY, scale: logoScale }}
        />
        <SectionImage2 
          as={motion.img} 
          src={window.innerWidth <= 991 ? home_people_mobile : home_people} 
          alt="Hero"
          style={{ y: peopleY }}
        />

        <SectionSubText as={motion.div} style={{ y: textY, opacity: textOpacity }}>
          <SectionText>
            [WITH SPOELT]<br />
            <br />
          </SectionText>
          Never pay retail price again, Period
        </SectionSubText>

        <MarqueeBanner as={motion.div} style={{ y: marqueeY, zIndex: 4, position: 'absolute', bottom: 0 }}>
          <Marquee>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
            <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
          </Marquee>
        </MarqueeBanner>
      </Section>

      <Container>
        <HeroSection as={motion.div} 
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, margin: "-100px" }}
        >
          <Header>
            <HeaderText>
              <HeaderBracketLeft>[</HeaderBracketLeft>
              <HeaderTextMain>WE ARE</HeaderTextMain>
              <HeaderBracketRight>]</HeaderBracketRight>
            </HeaderText>
            <Tagline>
              Curating deals for a members only community, leading to massive discounts.
            </Tagline>

            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <Button style={{ marginTop: 20 }} onClick={() => navigate('/about')}>
                <span style={{ color: 'black' }}>About Us</span>
                <LearnMoreButtonIcon>
                  <LearnMoreButtonIconImage src={learnMoreArrow} alt="Arrow icon" />
                </LearnMoreButtonIcon>
              </Button>
            </div>
          </Header>
        </HeroSection>

        <Main>
          <ContentWrapper>
            {data.map((item, index) => (
              <FeatureSection key={index} as={motion.section}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <FeatureContent>
                  <FeatureTitle>
                    <FeatureLeftBracket>[</FeatureLeftBracket>
                    <FeatureTitleText>{item.title}</FeatureTitleText>
                    <FeatureRightBracket>]</FeatureRightBracket>
                  </FeatureTitle>
                  <FeatureNumber>{item.number}</FeatureNumber>
                  <FeatureDescription>{item.description}</FeatureDescription>
                  <FeatureButton onClick={() => navigate('/elts', { state: { elts: true } })}>
                    <FeatureButtonText>{item.buttonText}</FeatureButtonText>
                    <FeatureButtonIcon src={featureButtonIcon} alt="Feature Button Icon" />
                  </FeatureButton>
                </FeatureContent>
              </FeatureSection>
            ))}
            <JoinUsSection as={motion.section}
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <JoinUsContent>
                <JoinUsTitle>Join Us</JoinUsTitle>

                <SubTagline>
                  We are building in stealth and launching communities in Goa, Karnataka, Maharashtra & more regions.
                </SubTagline>
                <JoinClubButton onClick={checkTokenAndLogin}>
                  <JoinClubText>Join our community</JoinClubText>
                  <JoinClubIcon src={joinClubIcon} alt="Join Club Icon" />
                </JoinClubButton>
              </JoinUsContent>
            </JoinUsSection>
          </ContentWrapper>
        </Main>
        <FooterImage 
          as={motion.img}
          src={about_join_us} 
          alt="Footer Image" 
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        />

        {/* Modal for email confirmation */}
        <Modal
          open={modalOpen}
          onClose={handleModalClose}
          aria-labelledby="email-confirmation-modal"
          aria-describedby="email-confirmation-description"
        >
          <ModalContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <div style={{ textAlign: 'center' }}>
              <button onClick={handleModalClose} style={{ position: 'absolute', top: 10, right: 10, border: 'none', background: 'none', cursor: 'pointer' }}>
                <span style={{ fontSize: '20px', color: '#202023' }}>✖</span>
              </button>
              <ModalTitle>Use existing email?</ModalTitle>
              <ModalMessage>Do you want to use the email <strong>{email}</strong> to log in?</ModalMessage>
              <ButtonWrapper>
                <Button onClick={handleUseSameEmail} variant="contained">Use Same Email</Button>
                <Button onClick={handleUseDifferentEmail} style={{ backgroundColor: "#fff" }} variant="outlined">Use Different Email</Button>
              </ButtonWrapper>
            </div>
          </ModalContent>
        </Modal>

      </Container>
      <motion.div style={{
        display: "flex",
        width: "100%",
        maxWidth: "100%",
        flexDirection: "column",
        backgroundColor: "#eaebef",
        alignItems: "center",
        color: "#202023",
        fontWeight: 400,
        lineHeight: "130%",
        paddingTop: "50px",
        paddingBottom: "50px",
      }}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
      >
        <Image2 as={motion.img} 
          loading="lazy" 
          src={contentImage} 
          alt="" 
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        />

        <TaglineWrapper as={motion.div}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <TaglineLeft>[</TaglineLeft>
          <TaglineCenter>WE ARE</TaglineCenter>
          <TaglineRight>]</TaglineRight>
        </TaglineWrapper>

        <Subtitle as={motion.div}
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          viewport={{ once: true }}
        >
          Disrupting e-commerce one purchase at a time
        </Subtitle>

        <ButtonWrapper>
          <Button onClick={() => navigate('/about')}>
            <span style={{ color: 'black' }}>About Us</span>
            <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
          </Button>

          <Button onClick={() => navigate('/privacy')}>
            <span style={{ color: 'black' }}>Policies</span>
            <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
          </Button>

          <Button onClick={() => navigate('/privacy#brands')}>
            <span>Brands</span>
            <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
          </Button>



          <LoginButton onClick={checkTokenAndLogin}>
            <span style={{ color: 'black' }}>Already a member? login</span>
            <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
          </LoginButton>
        </ButtonWrapper>
      </motion.div>
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
      />
      <ScrollToBottomButton onClick={handleScrollButtonClick}>
        {scrollDirection === 'down' ? '↓' : '↑'} {/* Less bold arrow */}
      </ScrollToBottomButton>
    </ScreenContainer>
  );
}

const ScrollToBottomButton = styled.button`
  position: fixed;
  bottom: 50px;
  right: 20px;
  background-color: #e9fe53;
  border: 1px solid #202023;
  width: 50px;
  height: 50px;
  font-size: 24px;
  cursor: pointer;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #d4e74e;
  }

  @media (max-width: 991px) {
    background-color: #e9fe53;
    color: black;
  }
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  text-align: center;
`;

const ModalTitle = styled.h2`
  font-size: 24px;
  margin-bottom: 10px;
  color: #202023;
`;

const ModalMessage = styled.p`
  font-size: 16px;
  margin-bottom: 20px;
  color: #606060;
`;




const ScreenContainer = styled.div`
  height: 300vh; // 100vh for each of the three sections
 // width: 100%; // Making the container full width
`;
const HeroSection = styled.div`
width:768px; align-self:center;
@media (max-width: 991px) {
  width: 100%;
}
`;
const Section = styled.div`
  height: 100vh;
  width: 100%; // Making the section full width
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 991px) {
    height: 600px;
  }
`;

const SectionImage = styled.img`
  width: 100%;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
`;
const SectionImage2 = styled.img`
  width: 100%;
  object-fit: contain;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
`;
const JoinTheClub = styled.img`
  object-fit: contain;
  top: 0;
  left: 0;
  width: 50%;
  cursor: pointer; // Make it clickable
  @media (max-width: 991px) {
    width: 50%;
    align-self: flex-end;
   display: flex;
  left: 30%;
    position: relative;
    margin-top:10px;
   }
`;
const SectionText = styled.div`
  position: relative;
  color: #202023;
  font-size: 12px;
  font-family: 'Metrophobic', sans-serif;
  text-align: center;
  z-index: 1;
  @media (max-width: 991px) {
   text-align: left;
  }
`;

const SectionSubText = styled.div`
  position: relative;
  color: #202023;
  font-size: 21px;
  font-family: 'Metrophobic', sans-serif;
  text-align: center;
  line-height: 1.2;
  letter-spacing: 0.5px;
  bottom: 50px;
  flex-direction:column;
  display:flex;
  z-index: 1;
  @media (max-width: 991px) {
    width: 250px;
    text-align: left;
    font-size: 18px;
    bottom: 12%;
    left: 10%;
   }
`;

const MarqueeBanner = styled.div`
  width: 100%;
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  background-color: #E9FE53;
  padding: 10px 0;
  border-bottom: 1px solid #000;
  border-top: 1px solid #000;
`;

const Marquee = styled.div`
  display: flex;
  animation: marquee 15s linear infinite; // Continuous scrolling effect
  @keyframes marquee {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); } // Adjust based on the number of items
  }
`;
const MarqueeText = styled.div`
  font-size: 14px;
  color: #202023;
  padding: 0 2rem;
  white-space: nowrap; // Prevent text wrapping
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 0;
  }
`;

const Header = styled.header`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 80px;
  margin-top: 80px;

  @media (max-width: 991px) {
    margin-left: 10px;
  }
`;

const HeaderText = styled.div`
  display: flex;
  gap: 1px;
  font-size: 42px;
  color: #202023;
  font-weight: 400;
  letter-spacing: 0.84px;
  line-height: 130%;

  @media (max-width: 991px) {
    margin-left: 10px;
    font-size: 32px;
    line-height: 38px;
  }
`;

const HeaderBracketLeft = styled.span`
  font-family: Metrophobic, sans-serif;
  @media (max-width: 991px) {
    font-size: 22px;
  }
`;

const HeaderTextMain = styled.span`
  
  letter-spacing: 0.64px;
  margin: auto 0;
  font: 32px Metrophobic, sans-serif;
   @media (max-width: 991px) {
    font-size: 18px;
  }
`;

const HeaderBracketRight = styled.span`
  font-family: Metrophobic, sans-serif;
  @media (max-width: 991px) {
    font-size: 22px;
  }
`;

const Tagline = styled.h1`
  color: #202023;
  width: 825px;
  font: 800 60px/65px Inter, sans-serif;
  text-align: left;
  margin-top: 31px;

  @media (max-width: 991px) {
    width: 100%;
    font-size: 36px;
    line-height: 48px;
    margin-top: 10px;
  }
`;

const SubTagline = styled.p`
  color: #202023;
  letter-spacing: -0.42px;
  width: 425px;
  margin-bottom: 0px;
  margin-top: 0px;
 // margin: 0px 0 0 50px;
  font: 400 21px/27px Metrophobic, sans-serif;

  @media (max-width: 991px) {
    width: 100%;
    font-size: 18px;
    line-height: 22px;
  }
`;

const ImageWrapper2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  aspect-ratio: 20;
  width: 180px;
  max-width: 100%;
  align-self: center;
  right: 120px;
  @media (max-width: 991px) {
    right: 88px;
    align-self: flex-end;
  }
`;

const Image = styled.img`
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
`;

const Image3 = styled.img`
  aspect-ratio: 20;
  object-fit: auto;
  object-position: center;
  width: 100%;
  margin-left: auto;
`;

const LearnMoreButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  gap: 8px;
  padding: 15px 13px;
  width: 272px;
  max-width: 100%;
  margin-top: 24px;
 // margin: 24px 0 0 50px;

  @media (max-width: 991px) {
    width: 98%;
    margin-bottom: 20px;
  }
`;

const LearnMoreButtonText = styled.span`
  color: #202023;
  letter-spacing: -0.32px;
  text-transform: uppercase;
  font: 400 16px/130% Metrophobic, sans-serif;
`;

const LearnMoreButtonIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  //border: 1px solid rgba(32, 32, 35, 1);
  position: relative;
  aspect-ratio: 1.1;
  width: 11px;
  margin: auto 0;
`;

const LearnMoreButtonIconImage = styled.img`
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
`;

const LearnMoreButtonIconImage2 = styled.img`
  aspect-ratio: 1.1;
  object-fit: auto;
  object-position: center;
  width: 100%;
  fill: #202023;
  stroke-width: 1px;
  stroke: #202023;
  border: 1px solid rgba(32, 32, 35, 1);
`;

const Main = styled.main`
  align-self: center; // Center aligned
  z-index: 10;
  width:90%;
  max-width: 1100px;
  margin-top: 137px;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 40px;
    width:100%;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0px;
  }
`;

const FeatureSection = styled.section`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 50%;
  margin-left: 0px;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const FeatureContent = styled.div`
  border: 1px solid rgba(0, 0, 0, 1);
  background-color: #171717;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  font-size: 16px;
  color: #fff;
  font-weight: 400;
  line-height: 130%;
  padding: 14px 50px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
  }
`;

const FeatureTitle = styled.h3`
  align-self: start;
  display: flex;
  gap: 1px;
  font-weight: 500;
  white-space: nowrap;
  text-align: right;
  letter-spacing: -0.32px;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const FeatureLeftBracket = styled.span`
  font-family: Manrope, sans-serif;
`;

const FeatureTitleText = styled.span`
  font-family: Metrophobic, sans-serif;
  font-weight: 400;
  letter-spacing: 0.32px;
`;

const FeatureRightBracket = styled.span`
  font-family: Manrope, sans-serif;
`;

const FeatureNumber = styled.div`
  letter-spacing: -5.2px;
  margin-bottom: 15px;
  text-transform: uppercase;
  margin-top: 17px;
  font: 900 130px/86% Inter, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 92px;
  }
`;

const FeatureDescription = styled.p`
  margin: 0 21px 0 0;
  font: 20px/102% Inter, sans-serif;
  @media (max-width: 991px) {
    margin-right: 10px;
  }
`;


const FeatureButtonText = styled.span`
  font-family: Metrophobic, sans-serif;
`;

const FeatureButtonIcon = styled.img`
  aspect-ratio: 1.1;
  object-fit: auto;
  object-position: center;
  width: 11px;
  fill: #202023;
  stroke-width: 1px;
  stroke: #202023;
 // border: 1px solid rgba(32, 32, 35, 1);
  margin: auto 0;
`;

const JoinUsSection = styled.section`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 50%;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const JoinUsContent = styled.div`
  border: 1px solid rgba(0, 0, 0, 1);
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  color: #202023;
  font-weight: 400;
  line-height: 130%;
  padding: 10px 40px 35px 40px; // Updated left and right padding to 40px
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
  }
`;

const JoinUsTitle = styled.div`
  letter-spacing: -0.8px;
  margin-top: 36px;
  font: 800 80px Inter, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 40px;
    margin-bottom: 10px;
  }
`;

const PhoneNumberInput = styled.input`
  align-items: start;
  border-radius: 1.658px;
  border: 2px solid rgba(32, 32, 35, 1);
 // margin-top: 45px;
  letter-spacing: -0.4px;
  justify-content: center;
  padding: 27px 22px;
  font: 20px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
    height: 50px;
  }
`;



const JoinClubText = styled.span`
  font-family: Metrophobic, sans-serif;
`;

const JoinClubIcon = styled.img`
  aspect-ratio: 1.2;
  object-fit: auto;
  object-position: center;
  width: 18px;
  fill: #202023;
  stroke-width: 1.658px;
  stroke: #202023;
  //border: 2px solid rgba(32, 32, 35, 1);
  margin: auto 0;
`;

const FooterImage = styled.img`
  aspect-ratio: 1.54;
  object-fit: auto;
  object-position: center;
  width: 657px;
  margin-top: -18px;
  max-width: 100%;
  align-self:center;
  z-index:11
`;
const ImageWrapper = styled.div`
  width: 100%;
  
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const Image2 = styled.img`
  aspect-ratio: 4.17;
  object-fit: auto;
  object-position: center;
  width: 60%;
  margin-top: 20px;
`;

const TaglineWrapper = styled.div`
  align-self: center;
  display: flex;
  margin-top: 22px;
  gap: 1px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.32px;

`;

const TaglineLeft = styled.div`
  font-family: Manrope, sans-serif;
  @media (max-width: 991px) {
    font-size: 16px;
    margin-top: 10px;
  }
`;

const TaglineCenter = styled.div`
  text-align: right;
  font-family: Metrophobic, sans-serif;
  font-weight: 400;
  letter-spacing: 0.32px;
  @media (max-width: 991px) {
    font-size: 14px;
    margin-top: 10px;
  }
`;

const TaglineRight = styled.div`
  font-family: Manrope, sans-serif;
  @media (max-width: 991px) {
    font-size: 16px;
    margin-top: 10px;
  }
`;

const Subtitle = styled.div`
  text-align: center;
  letter-spacing: -0.42px;
  align-self: center;
  margin-top: 20px;
  font: 21px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    font-size: 16px;
    margin-top: 10px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  gap: 5px;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: -0.28px;
  padding: 0 1px;
  
  @media (max-width: 991px) {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
`;

const Button = styled.button`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  gap: 8px;
  padding: 16px 13px;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  width:260px;  
  text-transform: uppercase;
  white-space: nowrap;
  @media (max-width: 991px) {
   
    width: 96%;
  }

`;

const ButtonIcon = styled.img`
  aspect-ratio: 1.22;
  object-fit: auto;
  object-position: center;
  width: 11px;
  fill: #202023;
  stroke-width: 1px;
  stroke: #202023;
 // border: 1px solid rgba(32, 32, 35, 1);
  margin: auto 0;
`;

const LoginButton = styled(Button)`
  white-space: nowrap;
  
  @media (max-width: 991px) {
    white-space: initial;
  }
`;


const JoinClubButton = styled.div`
  justify-content: space-between;
  border-radius: 1.658px;
  border: 2px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  margin-top: 25px;
  gap: 13px;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: -0.36px;
  padding: 27px 22px;
  cursor: pointer; // Show mouse cursor on hover

  @media (max-width: 991px) {
    max-width: 100%;
    flex-wrap: wrap;
    padding: 0 20px;
    height: 50px;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }
`;

const FeatureButton = styled(Button)`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  margin-top: 34px;
  gap: 8px;
  color: #202023;
  text-transform: uppercase;
  letter-spacing: -0.32px;
  padding: 20px 13px;
  @media (max-width: 991px) {
    flex-wrap: wrap;
    margin-top: 20px;
    margin-bottom: 20px;
    width: 100%; 
  }
  width: 50%;
`;
